import { Effect } from "../../Materials/effect";
var name = 'fogVertexDeclaration';
var shader = "#ifdef FOG\nvarying vec3 vFogDistance;\n#endif";
Effect.IncludesShadersStore[name] = shader;
/** @hidden */
export var fogVertexDeclaration = { name: name, shader: shader };
//# sourceMappingURL=fogVertexDeclaration.js.map